```vue
<template>
  <BreadCrumb PageTitle="Détails et réponses de la session" />
  <ViewSessionReponse />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ViewSessionReponse from "@/components/Session/ViewSessionReponse.vue";

export default defineComponent({
  name: "ViewSessionReponsePage",
  components: {
    BreadCrumb,
    ViewSessionReponse,
  },
});
</script>
```